import { render } from "./TooltipComponent.vue?vue&type=template&id=3291c116&scoped=true"
import script from "./TooltipComponent.vue?vue&type=script&lang=js"
export * from "./TooltipComponent.vue?vue&type=script&lang=js"

import "./TooltipComponent.vue?vue&type=style&index=0&id=3291c116&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3291c116"]])

export default __exports__